module.exports = __webpack_public_path__ + "static/media/Ch1-light.a760b958.jpg";